// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UgrKW","label":"SetPasswdForm_label__3mDJt"};